const RESOURCE_NAME = "entities/questions";

export default {};
